/**
 * Figma Group 1321317992 (187:9232) — размеры и позиции `level_name_text`
 * для окон new_delivery / success_delivery (design px).
 */
export type LevelNameTextLayout = {
  left: number;
  top: number;
  width: number;
  height: number;
  fontSize: number;
};

/** Fallback: «Спиночесалка» (187:9198). */
export const DEFAULT_LEVEL_NAME_TEXT_LAYOUT: LevelNameTextLayout = {
  left: 374.5,
  top: 391.43,
  width: 336,
  height: 64,
  fontSize: 54,
};

/**
 * Ключ — название заказа без кавычек (как `GiantOrderDef.title`).
 * Значения — bbox + font-size из макета 187:9232.
 */
export const LEVEL_NAME_TEXT_LAYOUT_BY_TITLE: Record<
  string,
  LevelNameTextLayout
> = {
  Спиночесалка: {
    left: 374.5,
    top: 391.43,
    width: 336,
    height: 64,
    fontSize: 54,
  },
  'Листва пожухла': {
    left: 358.5,
    top: 391.43,
    width: 368,
    height: 64,
    fontSize: 54,
  },
  'Украшение для листвы': {
    left: 329.5,
    top: 396.43,
    width: 426,
    height: 53,
    fontSize: 45,
  },
  'Разобраться в себе': {
    left: 323.5,
    top: 391.43,
    width: 439,
    height: 64,
    fontSize: 54,
  },
  'Новая батарея': {
    left: 372.5,
    top: 391.43,
    width: 340,
    height: 64,
    fontSize: 54,
  },
  'Выпустить пар': {
    left: 372.5,
    top: 391.43,
    width: 341,
    height: 64,
    fontSize: 54,
  },
  'Что-нибудь на «Му»': {
    left: 329.5,
    top: 394.43,
    width: 426,
    height: 59,
    fontSize: 50,
  },
  'Музыкальная еда': {
    left: 341.5,
    top: 391.43,
    width: 402,
    height: 64,
    fontSize: 54,
  },
  ЯРКОЕ: {
    left: 456.5,
    top: 391.43,
    width: 173,
    height: 64,
    fontSize: 54,
  },
  Бессонница: {
    left: 397.5,
    top: 391.43,
    width: 290,
    height: 64,
    fontSize: 54,
  },
  Самозащита: {
    left: 395.5,
    top: 391.43,
    width: 295,
    height: 64,
    fontSize: 54,
  },
  'Спасательный круг': {
    left: 325.5,
    top: 391.43,
    width: 435,
    height: 64,
    fontSize: 54,
  },
  'Пассажиры зажигают': {
    left: 338.5,
    top: 396.43,
    width: 408,
    height: 53,
    fontSize: 45,
  },
  'Костюм для маскарада': {
    left: 326.5,
    top: 396.43,
    width: 432,
    height: 53,
    fontSize: 45,
  },
  'Прыгучие дельфины': {
    left: 334.5,
    top: 393.43,
    width: 417,
    height: 57,
    fontSize: 48,
  },
  'Вспомнить молодость': {
    left: 337.5,
    top: 396.43,
    width: 410,
    height: 53,
    fontSize: 45,
  },
  'Страшное чтение': {
    left: 343.5,
    top: 391.43,
    width: 399,
    height: 64,
    fontSize: 54,
  },
  'Игра на нервах': {
    left: 364.5,
    top: 391.43,
    width: 356,
    height: 64,
    fontSize: 54,
  },
  'Что-нибудь для памяти': {
    left: 325.5,
    top: 396.43,
    width: 433,
    height: 53,
    fontSize: 45,
  },
  'Расческа для усов': {
    left: 329.5,
    top: 391.43,
    width: 425,
    height: 64,
    fontSize: 54,
  },
  'Согреть вулкан': {
    left: 366.5,
    top: 391.43,
    width: 351,
    height: 64,
    fontSize: 54,
  },
  'Песня для вдохновения': {
    left: 331.5,
    top: 397.43,
    width: 421,
    height: 51,
    fontSize: 43,
  },
  Трогательное: {
    left: 383.5,
    top: 391.43,
    width: 317,
    height: 64,
    fontSize: 54,
  },
  'След в истории': {
    left: 365.5,
    top: 391.43,
    width: 353,
    height: 64,
    fontSize: 54,
  },
  'Острый перекус': {
    left: 354.5,
    top: 391.43,
    width: 375,
    height: 64,
    fontSize: 54,
  },
  'Что-то крутое': {
    left: 378.5,
    top: 391.43,
    width: 326,
    height: 64,
    fontSize: 54,
  },
  'Новый звук': {
    left: 405.5,
    top: 391.43,
    width: 272,
    height: 64,
    fontSize: 54,
  },
  'Ик… Икота': {
    left: 420.5,
    top: 391.43,
    width: 243,
    height: 64,
    fontSize: 54,
  },
  'Рифма к «пюре»': {
    left: 347.5,
    top: 391.43,
    width: 389,
    height: 64,
    fontSize: 54,
  },
  'Не спится': {
    left: 420.5,
    top: 391.43,
    width: 242,
    height: 64,
    fontSize: 54,
  },
  'Большая медведица': {
    left: 325.5,
    top: 392.43,
    width: 433,
    height: 60,
    fontSize: 51,
  },
  Милота: {
    left: 445.5,
    top: 391.43,
    width: 193,
    height: 64,
    fontSize: 54,
  },
  'Давненько не видела книги': {
    left: 333.5,
    top: 400.43,
    width: 416,
    height: 44,
    fontSize: 37,
  },
};

/** Снимает типографские кавычки макета с названия уровня. */
export function levelNameTitleKey(text: string): string {
  return text
    .replace(/\u00a0/g, ' ')
    .replace(/^[\s\u201c\u201d"«»]+|[\s\u201c\u201d"«»]+$/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function getLevelNameTextLayout(text: string): LevelNameTextLayout {
  const key = levelNameTitleKey(text);
  return (
    LEVEL_NAME_TEXT_LAYOUT_BY_TITLE[key] ?? DEFAULT_LEVEL_NAME_TEXT_LAYOUT
  );
}
